import React, { useState, useEffect, useRef } from "react";
import "./AddNewMember.css";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select from "../select/Select";
import { checkParams } from "../../../src/util/Util";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import LoadingButtonText from "../loadingButtonText/loadingButtonText";
// import CareTeam from "../careTeam/CareTeam";

const AddNewMember = (props) => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [patientSettings, setPatientSettings] = useState([]);
  const [selectedTab, setSelectedTab] = useState("Details");
  const [firstName, setFirstName] = useState("");
  const [errorFirstName, setErrorFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [birthday, setBirthday] = useState("");
  const [errorBirthDay, setErrorBirthDay] = useState("");
  const [errorProblem, setErrorProblem] = useState("");
  const [errorSubProblem, setErrorSubProblem] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [skipMedical, setSkipMedical] = useState("0");
  const [enableAR, setEnableAR] = useState("1");
  const [inviteMessage, setInviteMessage] = useState("1");
  const [skipCall, setSkipCall] = useState("0");
  const [problemAreas, setProblemAreas] = useState([]);
  const [subProblems, setSubProblems] = useState([]);
  const [addMemberProb, setAddMemberProb] = useState({});
  // const [therapistsList, setTherapistsList] = useState([]);
  const [therapistId, setTherapistId] = useState("");
  // eslint-disable-next-line
  const [practiceDoctor, setPracticeDoctor] = useState("");
  const [practiceDoctorName, setPracticeDoctorName] = useState("");
  const [practiceDoctorList, setPracticeDoctorList] = useState([]);
  // eslint-disable-next-line
  const [practice, setPractice] = useState("");
  const [practiceName, setPracticeName] = useState("");
  const [practiceList, setPracticeList] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [companySelected, setCompanySelected] = useState("");
  const [businessCompanies, setBusinessCompanies] = useState([]);
  const [companyType, setCompanyType] = useState("");
  const [memberLoaded, setMemberLoaded] = useState(false);
  const [errorTherapist, setErrorTherapist] = useState("");
  //const [selectedTab, setSelectedTab] = useState("Details");
  const [therapistList, setTherapistList] = useState([]);
  const [memberPermissions, setMemberPermissions] = useState([]);

  const [therapistName, setTherapistName] = useState("");
  const [problemArea, setProblemArea] = useState("");
  const [subProblem, setSubProblem] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [countryList] = useState([
    {
      value: "United States",
    },
    { value: "Canada" },
  ]);
  const [countrySelected, setCountrySelected] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [countryError, setCountryError] = useState("");
  const [memberRegistered, setMemberRegistered] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const userBusinessID =
    localStorage.getItem("userData") && JSON.parse(localStorage.getItem("userData"))
      ? JSON.parse(localStorage.getItem("userData")).business_id
      : -1;

  useEffect(() => {
    if (id > 0) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_programs/get-member-info", { id })
          .then((res) => {
            if (res.data.responseData) {
              setShowLoader(false);
              var memberInfo = res.data.responseData[0];
              var memberPermissionsInfo = res.data.responseData[1];
              let settingsObj = { ...patientSettings };

              //set Problem and Sub Problem name when entering in edit
              if (userBusinessID !== 0) {
                handleChangeProblems("problem_id", memberInfo.problem_id);
                settingsObj.problemId = memberInfo.problem_id;

                for (var subProb of subProblems) {
                  if (subProb.key === memberInfo.sub_problem_id) {
                    setSubProblem(subProb.value);
                    settingsObj.subProblemId = memberInfo.sub_problem_id;
                  }
                }
              }

              setSkipMedical(String(memberInfo.disable_quest));
              setEnableAR(String(memberInfo.ar_enabled));
              setInviteMessage(String(memberInfo.invite_message));
              setSkipCall(String(memberInfo.disable_oneonone));

              settingsObj.company_id = memberInfo.company_id;
              settingsObj.first_name = memberInfo.first_name;
              settingsObj.last_name = memberInfo.last_name;
              settingsObj.email = memberInfo.email;
              settingsObj.phone = memberInfo.phone;
              settingsObj.country = memberInfo.country;

              setEmail(memberInfo.email);
              setPhone(memberInfo.phone);
              setCountrySelected(memberInfo.country);
              setMemberRegistered(String(memberInfo.is_registered) === "1" ? true : false);

              settingsObj.birthday = memberInfo.birthday2;
              settingsObj.therapistId = memberInfo.therapist_id;
              settingsObj.practiceDoctorId = memberInfo.company_doctor_id;
              settingsObj.practiceId = memberInfo.company_practice_id;
              setPatientSettings(settingsObj);
              setMemberPermissions(memberPermissionsInfo);

              setFirstName(memberInfo.first_name);
              setLastName(memberInfo.last_name);
              handleBirthday(memberInfo.birthday2);
              setCompanyId(memberInfo.company_id);
              setCompanyError("");

              setMemberLoaded(true);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
    // eslint-disable-next-line
  }, [id, problemAreas, subProblems]);

  useEffect(() => {
    props.actSidebar(false);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/edit-details", {
          problem_id: addMemberProb.problem_id,
          patient_search: "",
        })
        .then((res) => {
          if (res.data.responseData) {
            var respState = function (stateName, inx) {
              stateName(res.data.responseData[inx]);
            };
            respState(setProblemAreas, 1);
            respState(setSubProblems, 2);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // eslint-disable-next-line
  }, [addMemberProb.problem_id]);

  useEffect(() => {
    // var patientData =
    //   localStorage.getItem("patientSettings") && JSON.parse(localStorage.getItem("patientSettings"))
    //     ? JSON.parse(localStorage.getItem("patientSettings"))
    //     : [];
    // if (patientData.length) {
    //   setPatientSettings(patientData);
    // }
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      if (userData.business_id === 0) {
        axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
        axios
          .post(window.ajaxLink + "cloud_programs/get-companies-by-bi", {
            business_id: userData.business_id,
          })
          .then((res) => {
            if (res.data.responseData) {
              var companies = res.data.responseData;

              if (companyId) {
                companies.forEach((itm) => {
                  if (itm.key === companyId) {
                    setCompanySelected(itm.value);
                    setCompanyType(itm.value.split(":")[0]);
                  }
                });
              }

              setBusinessCompanies(companies);
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
    // eslint-disable-next-line
  }, [addMemberProb, memberLoaded]);

  // useEffect(() => {
  //   var userData = JSON.parse(localStorage.getItem("userData"));
  //   if (userData === null) {
  //     props.checkLoggedIn(false);
  //   } else {
  //     axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
  //     axios
  //       .post(window.ajaxLink + "cloud_programs/get-therapists-by-bi", { business_id: userData.business_id })
  //       .then((res) => {
  //         if (res.data.responseData) {
  //           setTherapistsList(res.data.responseData);
  //         }
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   }
  // }, []);

  useEffect(() => {
    setShowLoader(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/get-practice-doctors-list", { companyId })
        .then((res) => {
          if (res.data.responseData) {
            setPracticeDoctorList(res.data.responseData);

            //set Practice Doctor in edit
            if (userBusinessID === 0 && id) {
              setPracticeDoctorName(
                (function () {
                  for (var doctor of res.data.responseData) {
                    setShowLoader(false);
                    if (doctor.key === patientSettings.practiceDoctorId) {
                      return doctor.value;
                    }
                  }
                })()
              );
              setShowLoader(false);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // eslint-disable-next-line
  }, [companyId]);

  useEffect(() => {
    setShowLoader(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/get-practice-list", { companyId })
        .then((res) => {
          if (res.data.responseData) {
            setPracticeList(res.data.responseData);

            //set Refer Doctor in edit
            if (userBusinessID === 0 && id) {
              setPracticeName(
                (function () {
                  for (var referDoc of res.data.responseData) {
                    setShowLoader(false);
                    if (referDoc.key === patientSettings.practiceId) {
                      return referDoc.value;
                    }
                  }
                })()
              );
              setShowLoader(false);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
    // eslint-disable-next-line
  }, [companyId]);

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRef = useRef(errorPopUp);
  useEffect(() => {
    popupRef.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  const handleFirstName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setFirstName(val);
    if (!checkParams(val, "firstname")) {
      setErrorFirstName("Please enter a valid first name.");
    } else if (val.length > 15) {
      setErrorFirstName("Maximal numbers of letters is 15.");
    } else {
      setErrorFirstName("");
    }
  };

  
  // const handleSelectedTherapist = (i) => {
  //   const data = [...therapistList];
  //   data[i].selected = !data[i].selected;
  //   setTherapistList(data);
  // };

  // const handleSelectedModal = (i) => {
  //   const data2 = [...therapistList];
  //   for (var d of data2) {
  //     if (d !== data2[i]) d.modalOpened = false;
  //   }
  //   data2[i].modalOpened = !data2[i].modalOpened;
  //   setTherapistList(data2);
  // };

  // const handleSelectedPermissions = (t, p) => {
  //   const ther = [...therapistList];
  //   const perm = [...ther[t].permissions];
  //   perm[p].value = !perm[p].value;

  //   if (perm[p].key === "All Premissions" && perm[p].value) {
  //     perm.forEach((p) => {
  //       p.value = true;
  //       ther[t].modalOpened = false;
  //     });
  //   } else if (perm[p].key === "All Premissions" && !perm[p].value) {
  //     perm.forEach((p) => {
  //       p.value = false;
  //     });
  //   }
  //   setTherapistList(ther);
  // };

  // const displaySelected = (i) => {
  //   const therapSelect = [...therapistList];
  //   var selectedOptions = [];
  //   therapSelect[i].permissions.map((sel) => {
  //     if (sel.value === true) {
  //       selectedOptions.push(sel.key);
  //     }
  //   });
  //   var optionsToDisplay = "";
  //   if (selectedOptions.length > 1) {
  //     optionsToDisplay = selectedOptions.join(", ");
  //   } else {
  //     optionsToDisplay = selectedOptions[0];
  //   }
  //   return optionsToDisplay;
  // };

  // const handleCloseAll = () => {
  //   const data3 = [...therapistList];
  //   for (var d of data3) {
  //     d.modalOpened = false;
  //   }
  //   setTherapistList(data3);
  // };

  const handleLastName = (val) => {
    val = val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
    setLastName(val);
    if (!checkParams(val, "lastname")) {
      setErrorLastName("Please enter a valid last name.");
    } else if (val.length > 15) {
      setErrorLastName("Maximal numbers of letters is 15.");
    } else {
      setErrorLastName("");
    }
  };

  const handleMail = (value) => {
    setEmail(value);
    if (value.trim() === ""){
      setErrorEmail("")
    } else if (!checkParams(value.trim(), "email")) {
      setErrorEmail("Please enter a valid email address.");
    } else {
      setErrorEmail("");
    }
  };

  const testDateValidity = (opt) => {
    let reg = /^(?:(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])(19|20)[0-9]{2})$/;

    if (reg.test(opt)) {
      var fixedOpt = opt.replace(reg, "$1/$2/$3" + opt[opt.length - 2] + opt[opt.length - 1]);
      const nowYear = new Date().getFullYear();
      let yearToCompare = fixedOpt.split("/");
      let isAdultValidation = parseInt(nowYear) - parseInt(yearToCompare[2]);
      if (isAdultValidation < 18) {
        return false;
      }
      return fixedOpt;
    } else {
      return false;
    }
  };

  const handlePhone = (subjectString) => {
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    setErrorPhone("");

    if (phoneRegex.test(subjectString)) {
      var formattedPhoneNumber = subjectString.replace(phoneRegex, "($1) $2-$3");
      setPhone(formattedPhoneNumber);
    } else {
      setErrorPhone("Please enter a valid US mobile number.");
      setPhone(subjectString);
    }
  };

  const handleBirthday = (val) => {
    var strippedValue = val;

    if (
      strippedValue !== "" &&
      /^((0?[1-9]|1[012])[- /.](0?[1-9]|[12][0-9]|3[01])[- /.](19|20)?[0-9]{4})*$/.test(strippedValue)
    ) {
      // valid date, check for missing zeros
      strippedValue = strippedValue.split("/");
      if (strippedValue[0].length === 1) {
        strippedValue[0] = "0" + strippedValue[0];
      }
      if (strippedValue[1].length === 1) {
        strippedValue[1] = "0" + strippedValue[1];
      }
      strippedValue = strippedValue.join("");
    }
// eslint-disable-next-line
    if (/[\/]/.test(strippedValue)) {
      strippedValue = strippedValue.split("/");
      strippedValue = strippedValue.join("");
    }
    // eslint-disable-next-line
    if (/[\.]/.test(strippedValue)) {
      strippedValue = strippedValue.split(".");
      strippedValue = strippedValue.join("");
    }

    if (!!testDateValidity(strippedValue) === true) {
      if (errorBirthDay) {
        setErrorBirthDay("");
      }
      setBirthday(testDateValidity(strippedValue));
    } else {
      setBirthday(val);
      if (!errorBirthDay) {
        setErrorBirthDay("User have to be over 18 to proceed.");
      }
    }
  };

  const handleTherapistId = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      let settingsObj = { ...patientSettings };
      let therapistListData = [...therapistList];

      for (var one of therapistListData) {
        if (one.mainTherapist === true) {
          one.selected = false;
          one.mainTherapist = false;
          for (var oneP of one.permissions) {
            oneP.value = false;
          }
        }
      }

      const ther = therapistListData.find((therapist) => therapist.id === value);
      ther.selected = true;
      ther.mainTherapist = true;
      setTherapistName(ther.username);
      ther.permissions.forEach((p) => {
        p.value = true;
      });
      settingsObj.therapistId = value;
      setPatientSettings(settingsObj);
    }
  };

  const handlePracticeDoctors = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      let settingsObj = { ...patientSettings };
      settingsObj.practiceDoctorId = value;

      setPracticeDoctorName(
        (function () {
          for (var doctor of practiceDoctorList) {
            if (doctor.key === value) {
              return doctor.value;
            }
          }
        })()
      );

      setPatientSettings(settingsObj);
    }
  };

  const handlePractice = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      let settingsObj = { ...patientSettings };
      settingsObj.practiceId = value;

      setPracticeName(
        (function () {
          for (var referDoc of practiceList) {
            if (referDoc.key === value) {
              return referDoc.value;
            }
          }
        })()
      );

      setPatientSettings(settingsObj);
    }
  };

  const handleCompanyList = (callVal, value, key) => {
    if (callVal && value) {
      for (let i of businessCompanies) {
        if (i.key === value) {
          var companyType = i.value.split(":")[0];
          setCompanySelected(i.value);
          setCompanyType(companyType);
        }
      }
      callVal(value);
      let settingsObj = { ...patientSettings };
      settingsObj.company_id = value;
      setPatientSettings(settingsObj);
      setCompanyError("");
    }
  };

  const handleSkipMedical = () => {
    if (skipMedical === "0") {
      setSkipMedical("1");
    } else if (skipMedical === "1") {
      setSkipMedical("0");
    }
  };

  const handleEnableAR = () => {
    if (enableAR === "0") {
      setEnableAR("1");
    } else if (enableAR === "1") {
      setEnableAR("0");
    }
  };

  const handleInviteMessage = () => {
    if (inviteMessage === "0") {
      setInviteMessage("1");
    } else if (inviteMessage === "1") {
      setInviteMessage("0");
    }
  };

  const handleSkipCall = () => {
    setErrorTherapist("");
    if (skipCall === "0") {
      setSkipCall("1");
    } else if (skipCall === "1") {
      setSkipCall("0");
    }
  };

  const handleCancel = () => {
    navigate("/settings");
  };

  const handleSaveMember = () => {
    var someIncomplete = true;

    if (id) {
      localStorage.setItem("fromEditMember", true);
    } else {
      localStorage.removeItem("fromEditMember");
    }

    if (userBusinessID !== 0) {
      var userData = JSON.parse(localStorage.getItem("userData"));
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        if (!therapistId && parseInt(skipCall) === 1) {
          setErrorTherapist("Please select a therapist or disable 1-to-1 call.");
          someIncomplete = true;
        } else if (
          firstName.length > 1 &&
          lastName.length > 1 &&
          birthday.length > 9 &&
          errorFirstName.length === 0 &&
          errorLastName.length === 0 &&
          errorEmail.length === 0 &&
          errorPhone.length === 0 &&
          countrySelected !== "" &&
          countryError.length === 0 &&
          errorBirthDay.length === 0 &&
          errorTherapist.length === 0 &&
          patientSettings &&
          patientSettings.problemId > 0 &&
          patientSettings.subProblemId > 0
        ) {
          someIncomplete = false;
          setSubmitting(true);
          axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
          axios
            .post(window.ajaxLink + "cloud_programs/save-new-member", {
              firstName,
              lastName,
              email: email.trim().toLowerCase(),
              phone,
              country: countrySelected,
              birthday,
              therapistId: patientSettings.therapistId || 0,
              practiceDoctorId: patientSettings.practiceDoctorId || 0,
              practiceId: patientSettings.practiceId || 0,
              problemId: patientSettings.problemId,
              subProblemId: patientSettings.subProblemId,
              business_id: userData.business_id,
              company_id: patientSettings.company_id ? patientSettings.company_id : userData.company_id,
              skipMedical: parseInt(skipMedical),
              skipCall: parseInt(skipCall),
              editId: id,
              selectedTherapists: therapistList,
              enableAR: parseInt(enableAR),
              inviteMessage: isNaN(parseInt(inviteMessage)) ? 1 : parseInt(inviteMessage),
            })
            .then((res) => {
              if (res.data.responseData) {
                localStorage.setItem("newMemberAdded", "true");
                navigate("/settings");
              }
            })
            .catch((error) => {
              console.error(error);
              if (error.response.data.errorData.emailError) {
                setErrorEmail(error.response.data.errorData.emailError);
              }
              if (error.response.data.errorData.phoneError) {
                setErrorPhone(error.response.data.errorData.phoneError);
              }
              someIncomplete = false;
            }).finally(() => {
              setSubmitting(false);
            });
        } else if (firstName.length < 2) {
          setErrorFirstName("Please enter a valid first name.");
        } else if (lastName.length < 2) {
          setErrorLastName("Please enter a valid last name.");
        } else if (birthday.length < 10) {
          setErrorBirthDay("User have to be over 18 to proceed.");
        } else if (countrySelected.length === 0 || countrySelected === "") {
          setCountryError("Please select a patient's country.");
        } else if (patientSettings.problemId === undefined) {
          setErrorProblem("Please fill in Problem Area.");
        } else if (patientSettings.subProblemId === undefined) {
          setErrorSubProblem("Please fill in Sub Problem.");
        }
      }
    } else {
      if (userData === null) {
        props.checkLoggedIn(false);
      } else {
        if (
          firstName.length > 1 &&
          lastName.length > 1 &&
          birthday.length > 9 &&
          errorFirstName.length === 0 &&
          errorLastName.length === 0 &&
          countrySelected !== "" &&
          countryError.length === 0 &&
          errorBirthDay.length === 0 &&
          patientSettings &&
          patientSettings.company_id > 0
        ) {
          someIncomplete = false;
          setSubmitting(true);
          axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
          axios
            .post(window.ajaxLink + "cloud_programs/save-new-member", {
              firstName,
              lastName,
              email: email.trim().toLowerCase(),
              phone,
              country: countrySelected,
              birthday,
              therapistId: patientSettings.therapistId || 0,
              practiceDoctorId: patientSettings.practiceDoctorId || 0,
              practiceId: patientSettings.practiceId || 0,
              problemId: patientSettings.problemId,
              subProblemId: patientSettings.subProblemId,
              business_id: userBusinessID,
              company_id: patientSettings.company_id ? patientSettings.company_id : userData.company_id,
              skipMedical: parseInt(skipMedical),
              skipCall: parseInt(skipCall),
              editId: id,
              selectedTherapists: therapistList,
              enableAR: parseInt(enableAR),
              inviteMessage: isNaN(parseInt(inviteMessage)) ? 1 : parseInt(inviteMessage),
            })
            .then((res) => {
              if (res.data.responseData) {
                localStorage.setItem("newMemberAdded", "true");
                navigate("/settings");
              }
            })
            .catch((error) => {
              console.error(error);
              if (error.response.data.errorData.emailError) {
                setErrorEmail(error.response.data.errorData.emailError);
              }
              if (error.response.data.errorData.phoneError) {
                setErrorPhone(error.response.data.errorData.phoneError);
              }
              someIncomplete = false;
            }).finally(() => {
              setSubmitting(false);
            });;
        } else if (patientSettings.company_id === undefined) {
          setCompanyError("Please fill in Company / Practice.");
        } else if (firstName.length < 2) {
          setErrorFirstName("Please enter a valid first name.");
        } else if (lastName.length < 2) {
          setErrorLastName("Please enter a valid last name.");
        } else if (birthday.length < 10) {
          setErrorBirthDay("User have to be over 18 to proceed.");
        } else if (countrySelected.length === 0 || countrySelected === "") {
          setCountryError("Please select a patient's country.");
        }
      }
    }
    if (someIncomplete && selectedTab === "Team") {
      setErrorPopUp("Please fill in all the necessary member info data.");
    }
  };

  // useEffect(() => {
  //   var patientData =
  //     localStorage.getItem("patientSettings") && JSON.parse(localStorage.getItem("patientSettings"))
  //       ? JSON.parse(localStorage.getItem("patientSettings"))
  //       : [];
  //   if (patientData.length) {
  //     setPatientSettings(patientData);
  //   }
  // }, [patientSettings]);

  // eslint-disable-next-line
  const handleSelectedTab = (tab) => {
    setSelectedTab(tab);
  };

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_programs/get-care-team-list", { business_id: userBusinessID })
      .then((res) => {
        if (res.data.responseData) {
          setTherapistList(res.data.responseData);

          //set Therapist name when entering in edit
          if (userBusinessID !== 0) {
            let therapistListData = [...res.data.responseData];
            const ther = therapistListData.find((therapist) => therapist.id === patientSettings.therapistId);
            if (ther) {
              ther.selected = true;
              ther.mainTherapist = true;
              setTherapistName(ther.username);
              setTherapistId(ther.id);
            }
          }

          if (res.data.responseData && memberPermissions) {
            for (var oneMember of memberPermissions) {
              for (var oneList of res.data.responseData) {
                if (oneList.id === oneMember.therapist_id) {
                  oneList.selected = true;
                  for (var perm of oneList.permissions) {
                    if (oneMember.read_messages === 1 && perm.key === "Read Messages") {
                      perm.value = true;
                    } else if (oneMember.request_onetoone === 1 && perm.key === "Request OneToOne") {
                      perm.value = true;
                    } else if (oneMember.respond_messages === 1 && perm.key === "Respond Messages") {
                      perm.value = true;
                    } else if (oneMember.update_file === 1 && perm.key === "Update File") {
                      perm.value = true;
                    } else if (oneMember.view_file === 1 && perm.key === "View File") {
                      perm.value = true;
                    } else if (oneMember.view_monitoring === 1 && perm.key === "View Monitoring") {
                      perm.value = true;
                    } else if (oneMember.notifications === 1 && perm.key === "Notifications") {
                      perm.value = true;
                    } else if (oneMember.edit_program === 1 && perm.key === "Edit Program") {
                      perm.value = true;
                    } else if (oneMember.ce_assessment === 1 && perm.key === "CE Assessment") {
                      perm.value = true;
                    } else if (oneMember.attend_onetoone === 1 && perm.key === "Attend OneToOne") {
                      perm.value = true;
                    } else if (oneMember.assign_program === 1 && perm.key === "Assign Program") {
                      perm.value = true;
                    }
                  }
                }
              }
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      });
      // eslint-disable-next-line
  }, [memberPermissions]);

  const handleChangeProblems = (paramToChange, value) => {
    var progArr = { ...addMemberProb };
    progArr[paramToChange] = value;

    if (paramToChange === "problem_id") {
      let settingsObj = { ...patientSettings };
      settingsObj.problemId = value;

      for (var problem of problemAreas) {
        if (problem.key === value) {
          setProblemArea(problem.value);
        }
      }

      setPatientSettings(settingsObj);
      setErrorProblem("");
      /* axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/edit-details", {
          problem_id: value,
          patient_search: "",
        })
        .then((res) => {
          if (res.data.responseData) {
            let useData = res.data.responseData[2];
            let useData2 = res.data.responseData[1];
            setSubProblems(useData);
            for (var obj in useData2) {
              if (useData2[obj].key === value) {
                progArr.problem_name = useData2[obj].value;
              }
            }
            progArr.sub_problem_id = useData[0].key;
            progArr.sub_problem_name = useData[0].value;
          }
        })
        .catch((error) => {
          console.error(error);
        }); */
    } else {
      let settingsObj = { ...patientSettings };
      settingsObj.subProblemId = value;

      for (var subProb of subProblems) {
        if (subProb.key === value) {
          setSubProblem(subProb.value);
        }
      }

      setPatientSettings(settingsObj);
      setErrorSubProblem("");
    }
    setAddMemberProb(progArr);
  };

  return (
    <div className="patient_settings_container">
      <Breadcrumbs></Breadcrumbs>
      <div className="add_member_title_and_btn_holder">
        <div className="prog_det_title_hold">
          <div className="prog_det_title">{id ? "Edit Member" : "Add New Member"}</div>
        </div>
      </div>
      <div className="add_member_tab_container">
        {/* <div className="add_member_tab_holder">
          <div className="tab_option_add_member">Member Details</div>
          <div className="slide_add_member"></div>
        </div>
        <div className="add_member_tab_holder">
          <div className="tab_option_add_member">Assign Team</div>
          <div className="slide_add_member"></div>
        </div> */}
        {/* <div className="programs_dash_top_options"> */}
          {/* <div className="programs_dash_contain_opts">
            <div
              className={"programs_dash_option" + (selectedTab === "Details" ? " p_d_option_selected" : "")}
              onClick={() => handleSelectedTab("Details")}
            >
              Member Details
            </div>
          </div> */}
          {/* <div className="programs_dash_contain_opts">
            <div
              className={"programs_dash_option" + (selectedTab === "Team" ? " p_d_option_selected" : "")}
              onClick={() => handleSelectedTab("Team")}
            >
              Assign Team
            </div>
          </div>
          <div className={"slide_add_member" + (selectedTab === "Team" ? " slide_opt_active" : "")}></div> */}
        {/* </div> */}
        <div className="add_member_btn_holder" style={{flex: 1, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end'}}>
          <div onClick={() => handleCancel()} className="cancel_btn_add_member">
            Cancel
          </div>
          <div onClick={() => handleSaveMember()} className="save_btn_add_member">
            <LoadingButtonText loading={submitting} text={"Save Member"} loadingText={"Saving Member"} />
          </div>
        </div>
      </div>
      {id > 0 && showLoader && (
        <div className="loader_full_container">
          <div className="p_load"></div>
        </div>
      )}
      <div className="add_member_hold" style={{ display: id > 0 && showLoader ? "none" : "block" }}>
        <div className="add_member_holder">
          <div className="input_wrapper_add_new_member">
            {selectedTab === "Details" && (
              <>
                <div className="add_member_patient_title">Member Details</div>
                {userBusinessID === 0 && (
                  <div>
                    <div style={{ marginTop: "0px", marginBottom: "10px" }} className="bottom_toggle_txt">
                      Company / Practice
                    </div>
                    <div className="relative_holder reg_select_wrapper mg-5">
                      <div style={{ marginBottom: "10px" }}>
                        <Select
                          placeholder={"Select Company"}
                          selectOptions={businessCompanies}
                          initVal={companySelected}
                          selectCallback={function (callVal, value) {
                            handleCompanyList(callVal, value);
                          }}
                          callBackValue={setCompanyId}
                        />
                      </div>
                    </div>
                    {companyError && <div className="email_error_msg">{companyError}</div>}
                  </div>
                )}
                {userBusinessID === 0 && companyId && companyType === "AOC" && (
                  <>
                    <div>
                      <div style={{ marginTop: "0px", marginBottom: "10px" }} className="bottom_toggle_txt">
                        Referring Practice
                      </div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div style={{ marginBottom: "10px" }}>
                          <Select
                            placeholder={"Select Referring Practice"}
                            selectOptions={practiceList}
                            initVal={practiceName}
                            selectCallback={function (callVal, value) {
                              handlePractice(callVal, value);
                            }}
                            callBackValue={setPractice}
                          />
                        </div>
                      </div>
                    </div>
                  <div>
                    <div style={{ marginTop: "0px", marginBottom: "10px" }} className="bottom_toggle_txt">
                      Practice Doctor
                    </div>
                    <div className="relative_holder reg_select_wrapper mg-5">
                      <div style={{ marginBottom: "10px" }}>
                        <Select
                          placeholder={"Select Practice Doctor"}
                          selectOptions={practiceDoctorList}
                          initVal={practiceDoctorName}
                          selectCallback={function (callVal, value) {
                            handlePracticeDoctors(callVal, value);
                          }}
                          callBackValue={setPracticeDoctor}
                        />
                      </div>
                    </div>
                  </div>
                  </>
                )}
                <div style={{ marginTop: companyError ? "0" : "16px" }} className="bottom_toggle_txt">
                  First Name
                </div>
                <input
                  placeholder="Enter First Name"
                  type="text"
                  value={firstName}
                  className="patient_info_input"
                  onChange={(e) => handleFirstName(e.currentTarget.value)}
                />
                {errorFirstName && <div className="email_error_msg">{errorFirstName}</div>}
                <div className={errorFirstName ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}>Last Name</div>
                <input
                  placeholder="Enter Last Name"
                  type="text"
                  value={lastName}
                  className="patient_info_input"
                  onChange={(e) => handleLastName(e.currentTarget.value)}
                />
                {errorLastName && <div className="email_error_msg">{errorLastName}</div>}
                <div className={errorFirstName ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}>Email</div>
                <input
                  type="text"
                  value={email}
                  placeholder="Optional"
                  className={"patient_info_input" + (memberRegistered ? " add_member_correct_input" : "")}
                  onChange={(e) => handleMail(e.currentTarget.value)}
                  disabled={memberRegistered}
                />
                {memberRegistered && (
                  <div className="add_member_correct">
                    <div className="prog_pop_icon_correct"></div>
                  </div>
                )}
                {errorEmail && <div className="email_error_msg">{errorEmail}</div>}
                <div className={errorEmail ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}>Phone</div>
                <input
                  type="text"
                  placeholder="e.g. 202-333-2222"
                  value={phone}
                  className="patient_info_input"
                  onChange={(e) => handlePhone(e.currentTarget.value)}
                />
                {errorPhone && <div className="email_error_msg">{errorPhone}</div>}
                <div className={errorPhone ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}>Country</div>
                <div className="patient_info_select">
                  <div className="relative_holder reg_select_wrapper">
                    <div>
                      <Select
                        placeholder={"Select Country"}
                        selectOptions={countryList}
                        selectCallback={function (callVal, value) {
                          //setStateSelected("");
                          callVal(value);
                          setCountryError("");
                        }}
                        initVal={countrySelected}
                        callBackValue={setCountrySelected}
                      />
                    </div>
                  </div>
                </div>
                {countryError && <div className="email_error_msg">{countryError}</div>}
                <div className={countryError ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}>Date of Birth</div>
                <input
                  placeholder="mm/dd/yyyy"
                  type="text"
                  value={birthday}
                  className="patient_info_input"
                  onChange={(e) => handleBirthday(e.currentTarget.value)}
                />
                {errorBirthDay && <div className="email_error_msg">{errorBirthDay}</div>}

                {userBusinessID !== 0 && (
                  <div>
                    <div className="select_wrapper_settings">
                      <div
                        style={{ marginBottom: "10px" }}
                        className={errorBirthDay ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}
                      >
                        Therapist
                      </div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div>
                          <Select
                            placeholder={"Select Therapist"}
                            initVal={therapistName}
                            selectOptions={(function () {
                              var therData = [];
                              for (var ther of therapistList) {
                                therData.push({ key: ther.id, value: ther.username });
                              }
                              return therData;
                            })()}
                            selectCallback={function (callVal, value) {
                              handleTherapistId(callVal, value);
                              setErrorTherapist("");
                            }}
                            callBackValue={setTherapistId}
                            //selectError={!stateSelected && stateSelectedError}
                          />
                          {errorTherapist && <div className="email_error_msg">{errorTherapist}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="select_wrapper_settings">
                      <div style={{ marginBottom: "10px" }} className="bottom_toggle_txt">
                        Problem Area
                      </div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div style={id ? {opacity: 0.5} : {}}>
                          <Select
                            placeholder={"Select Problem Area"}
                            initVal={problemArea}
                            selectOptions={problemAreas}
                            selectCallback={handleChangeProblems}
                            callBackValue={"problem_id"}
                            disabled={!!id}
                          />
                        </div>
                      </div>
                    </div>
                    {errorProblem && <div className="email_error_msg">{errorProblem}</div>}
                    <div className="select_wrapper_settings">
                      <div
                        style={{ marginBottom: "10px" }}
                        className={errorProblem ? "bottom_toggle_txt_err" : "bottom_toggle_txt"}
                      >
                        Sub Problem
                      </div>
                      <div className="relative_holder reg_select_wrapper mg-5">
                        <div>
                          <Select
                            placeholder={"Select Sub Problem"}
                            initVal={subProblem}
                            selectOptions={subProblems}
                            selectCallback={handleChangeProblems}
                            callBackValue={"sub_problem_id"}
                          />
                        </div>
                      </div>
                    </div>
                    {errorSubProblem && <div className="email_error_msg">{errorSubProblem}</div>}
                    <div
                      style={errorSubProblem ? { marginTop: "0px" } : { marginTop: "16px" }}
                      className="bottom_toggle_options"
                    >
                      <div
                        style={{ marginTop: "0px", color: memberRegistered && "rgba(170, 170, 170, 1)" }}
                        className="bottom_toggle_txt"
                      >
                        Skip Medical Questionnaire
                      </div>
                      <div>
                        <div
                          style={{ backgroundColor: memberRegistered && "#dee5e6" }}
                          onClick={() => !memberRegistered && handleSkipMedical()}
                          className={
                            "abr_switch " +
                            (skipMedical === "1" ? "abr_switch_active_add_member" : "abr_switch_inactive")
                          }
                        >
                          <div></div>
                        </div>
                      </div>
                    </div>
                    <div className="bottom_toggle_options">
                      <div
                        style={{ marginTop: "0px", color: memberRegistered && "rgba(170, 170, 170, 1)" }}
                        className="bottom_toggle_txt"
                      >
                        Skip Schedule a 1:1 Call
                      </div>
                      <div>
                        <div
                          style={{ backgroundColor: memberRegistered && "#dee5e6" }}
                          onClick={() => !memberRegistered && handleSkipCall()}
                          className={
                            "abr_switch " + (skipCall === "1" ? "abr_switch_active_add_member" : "abr_switch_inactive")
                          }
                        >
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  style={errorSubProblem ? { marginTop: "0px" } : { marginTop: "16px" }}
                  className="bottom_toggle_options"
                >
                  <div style={{ marginTop: "0px" }} className="bottom_toggle_txt">
                    Enable AR
                  </div>
                  <div>
                    <div
                      onClick={() => handleEnableAR()}
                      className={
                        "abr_switch " + (enableAR === "1" ? "abr_switch_active_add_member" : "abr_switch_inactive")
                      }
                    >
                      <div></div>
                    </div>
                  </div>
                </div>

                {userBusinessID === 0 && !id && companyId && (companyType === "AOC" || companyType === "SI") && (
                  <div
                    style={errorSubProblem ? { marginTop: "0px" } : { marginTop: "16px" }}
                    className="bottom_toggle_options"
                  >
                    <div style={{ marginTop: "0px" }} className="bottom_toggle_txt">
                      Send Invite Message
                    </div>
                    <div>
                      <div
                        onClick={() => handleInviteMessage()}
                        className={
                          "abr_switch " +
                          (inviteMessage === "1" ? "abr_switch_active_add_member" : "abr_switch_inactive")
                        }
                      >
                        <div></div>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
          {/* {selectedTab === "Team" && (
            <CareTeam
              handleSelectedTherapist={handleSelectedTherapist}
              therapistList={therapistList}
              handleSelectedModal={handleSelectedModal}
              handleSelectedPermissions={handleSelectedPermissions}
              handleCloseAll={handleCloseAll}
              displaySelected={displaySelected}
            />
          )} */}
        </div>
      </div>
      {errorPopUp && (
        <div className="prog_err_hold add_comm_prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text add_comm_prog_err_text">{errorPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default AddNewMember;
